import React from "react"
import { Box, Typography } from "@mui/material"
import { dateFormatReceiver } from "@utils"
import { formatDate } from "@ui-seeker/utils"


export default function createdColumn() {

	return [{
		name: "timestamp_create_tz",
		label: "Creation Date",
		options: {
			display: 'excluded',
			customBodyRowRender: value => formatDate(value, {
				isString: true,
				receivedFormat: dateFormatReceiver(value),
				format: "dd MMM yyyy HH:mm:ss"
			})
		}
	},
		{
			name: "timestamp_create_tz",
			label: "Creation Date",
			options: {
				filter: false,
				customBodyRowRenderLite: value => {
					return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
						<Typography variant="body3">
							{formatDate(value, {
								isString: true,
								receivedFormat: dateFormatReceiver(value),
								format: "dd MMM yyyy"
							})}</Typography>
						<Typography variant="caption" sx={{ color: "text.secondary" }}>
							{formatDate(value, {
								isString: true,
								receivedFormat: dateFormatReceiver(value),
								format: "HH:mm:ss"
							})}</Typography>
					</Box>
				}
			}
		}
	]
}